import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix d-flex flex-wrap" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-3" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "input-group-btn" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-3" };
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-3" };
const _hoisted_14 = { class: "input-group top_search" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-3" };
const _hoisted_16 = { class: "input-group top_search" };
const _hoisted_17 = { class: "clearfix d-flex flex-wrap" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-4" };
const _hoisted_19 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_20 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-2" };
const _hoisted_24 = { class: "input-group top_search" };
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-2" };
const _hoisted_26 = { class: "input-group top_search" };
const _hoisted_27 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-2" };
const _hoisted_28 = { class: "input-group top_search" };
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-2" };
const _hoisted_30 = { class: "input-group top_search" };
const _hoisted_31 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_32 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_33 = { class: "float-end left5" };
const _hoisted_34 = { class: "clearfix pad10" };
const _hoisted_35 = { class: "float-end" };
const _hoisted_36 = { class: "float-end" };
const _hoisted_37 = { class: "float-end hidden-xs record-count" };
const _hoisted_38 = { class: "col-xs-12 col-sm-12" };
const _hoisted_39 = { class: "card bg-white data-grid issues-grid detached overflow-x-auto" };
const _hoisted_40 = { class: "table table-hover bottom0 pw100" };
const _hoisted_41 = {
    key: 0,
    class: "no-min-width"
};
const _hoisted_42 = { key: 1 };
const _hoisted_43 = { key: 2 };
const _hoisted_44 = { key: 3 };
const _hoisted_45 = { key: 4 };
const _hoisted_46 = { key: 5 };
const _hoisted_47 = { key: 6 };
const _hoisted_48 = { key: 7 };
const _hoisted_49 = ["onClick"];
const _hoisted_50 = { key: 0 };
const _hoisted_51 = { key: 1 };
const _hoisted_52 = { key: 2 };
const _hoisted_53 = ["title"];
const _hoisted_54 = { key: 4 };
const _hoisted_55 = { key: 5 };
const _hoisted_56 = { key: 6 };
const _hoisted_57 = { key: 7 };
const _hoisted_58 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[85] || (_cache[85] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "Issues")
            ], -1 /* CACHED */)),
            _cache[86] || (_cache[86] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.exportIssuesCSV
                    }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Export CSV", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[18] || (_cache[18] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.exportIssuesPDF
                    }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Export PDF", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    _createVNode(_component_router_link, { to: { name: 'issue' } }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_button, { variant: "primary" }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Add Issue", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]),
            _cache[87] || (_cache[87] = _createTextVNode()),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.query.keywords,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                    placeholder: "Search for...",
                                    onKeyup: _withKeys(_ctx.search, ["enter"]),
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "onKeyup", "disabled"]),
                                _cache[21] || (_cache[21] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_10, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-default",
                                        onClick: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            (...args) => (_ctx.search && _ctx.search(...args))),
                                        style: { "height": "34px" }
                                    }, [...(_cache[20] || (_cache[20] = [
                                            _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                        ]))])
                                ])
                            ])
                        ]),
                        _cache[25] || (_cache[25] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.company,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.company) = $event)),
                                    options: _ctx.companies,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All companies",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _cache[26] || (_cache[26] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.site,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.site) = $event)),
                                    options: _ctx.filteredSites,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All sites",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _cache[27] || (_cache[27] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.action,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.action) = $event)),
                                    options: _ctx.actionTypes,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All actions",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ])
                    ]),
                    _cache[80] || (_cache[80] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            (!_ctx.showDatePickers)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                        return _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                            class: "pw100",
                                            disabled: _ctx.working,
                                            key: idx,
                                            variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                            onClick: ($event) => (_ctx.setDateFilterOption(item)),
                                            title: _ctx.getPeriodTitle(item)
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick", "title"])), [
                                            [
                                                _directive_b_tooltip,
                                                void 0,
                                                void 0,
                                                { hover: true }
                                            ]
                                        ]);
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[34] || (_cache[34] = _createTextVNode()),
                            (_ctx.showDatePickers)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_b_input_group, {
                                            class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_flat_pickr, {
                                                    class: "form-control",
                                                    modelValue: _ctx.query.startTime,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.startTime) = $event)),
                                                    config: _ctx.datePickerConfig,
                                                    placeholder: "From date",
                                                    disabled: _ctx.working
                                                }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                _cache[29] || (_cache[29] = _createTextVNode()),
                                                _createVNode(_component_b_input_group_append, null, {
                                                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                            _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                                _createElementVNode("button", {
                                                                    type: "button",
                                                                    class: "btn btn-default",
                                                                    "data-toggle": ""
                                                                }, [
                                                                    _createElementVNode("i", { class: "fa fa-calendar" })
                                                                ])
                                                            ], -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["class"])
                                    ]),
                                    _cache[33] || (_cache[33] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_component_b_input_group, {
                                            class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_flat_pickr, {
                                                    class: "form-control",
                                                    modelValue: _ctx.query.endTime,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.endTime) = $event)),
                                                    config: _ctx.datePickerConfig,
                                                    placeholder: "Until date",
                                                    disabled: _ctx.working
                                                }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                _cache[32] || (_cache[32] = _createTextVNode()),
                                                _createVNode(_component_b_input_group_append, null, {
                                                    default: _withCtx(() => [
                                                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-default",
                                                                "data-toggle": ""
                                                            }, [
                                                                _createElementVNode("i", { class: "fa fa-calendar" })
                                                            ])
                                                        ], -1 /* CACHED */)),
                                                        _cache[31] || (_cache[31] = _createTextVNode()),
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-secondary",
                                                            onClick: _cache[7] || (_cache[7] =
                                                                //@ts-ignore
                                                                (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                        }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["class"])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _cache[39] || (_cache[39] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.createdBy,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.createdBy) = $event)),
                                    options: _ctx.creators,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All creators",
                                    allowEmpty: true,
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _cache[40] || (_cache[40] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.assigned,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.assigned) = $event)),
                                    options: _ctx.assignees,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All assignees",
                                    allowEmpty: true,
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _cache[41] || (_cache[41] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.category,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.category) = $event)),
                                    options: _ctx.categoryTypes,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All categories",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _cache[42] || (_cache[42] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.severity,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.severity) = $event)),
                                    options: _ctx.severityTypes,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All severities",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ])
                    ]),
                    _cache[81] || (_cache[81] = _createTextVNode()),
                    (_ctx.searchAttempted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_b_dropdown, {
                                        ref: "columnSettingsDropdown",
                                        "no-caret": "",
                                        end: "",
                                        sm: "",
                                        "auto-close": false,
                                        variant: "outline-secondary outline-secondary-pagination",
                                        disabled: _ctx.working
                                    }, {
                                        "button-content": _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                                _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* CACHED */)
                                            ]))]),
                                        default: _withCtx(() => [
                                            _cache[49] || (_cache[49] = _createTextVNode()),
                                            _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_form_group, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_form_checkbox, {
                                                                id: "includeDeleted",
                                                                modelValue: _ctx.query.includeDeleted,
                                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _cache[45] || (_cache[45] = _createTextVNode()),
                                                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "clearfix top10" }, [
                                                        _createElementVNode("label", null, "Column visibility")
                                                    ], -1 /* CACHED */)),
                                                    _cache[47] || (_cache[47] = _createTextVNode()),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                                                        return (_openBlock(), _createBlock(_component_b_form_group, {
                                                            key: column.fieldName
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    id: column.fieldName,
                                                                    modelValue: column.visible,
                                                                    "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1024 /* DYNAMIC_SLOTS */));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _cache[50] || (_cache[50] = _createTextVNode()),
                                            _createVNode(_component_b_dropdown_divider),
                                            _cache[51] || (_cache[51] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_34, [
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createVNode(_component_b_button, {
                                                        variant: "secondary",
                                                        right: "",
                                                        sm: "",
                                                        onClick: _ctx.closeColumnSettingsMenu
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                                _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"])
                                                ])
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled"])
                                ]),
                                _cache[52] || (_cache[52] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_b_pagination, {
                                        class: "float-end",
                                        modelValue: _ctx.query.page,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.query.page) = $event)),
                                        "per-page": _ctx.query.pageSize,
                                        "total-rows": _ctx.data.recordCount,
                                        "hide-ellipsis": true,
                                        disabled: _ctx.working
                                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                ]),
                                _cache[53] || (_cache[53] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_37, "\r\n\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[82] || (_cache[82] = _createTextVNode()),
                    _cache[83] || (_cache[83] = _createElementVNode("div", { class: "clearfix top10" }, null, -1 /* CACHED */)),
                    _cache[84] || (_cache[84] = _createTextVNode()),
                    _withDirectives(_createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("table", _hoisted_40, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _cache[54] || (_cache[54] = _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* CACHED */)),
                                        _cache[55] || (_cache[55] = _createTextVNode()),
                                        (_ctx.isVisible('issueId'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_41, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'issueNumber', title: '#' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[56] || (_cache[56] = _createTextVNode()),
                                        (_ctx.isVisible('created'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_42, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'WhenCreated', title: 'Created' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[57] || (_cache[57] = _createTextVNode()),
                                        (_ctx.isVisible('system'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_43, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'SystemName', title: 'System' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[58] || (_cache[58] = _createTextVNode()),
                                        (_ctx.isVisible('description'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_44, "Description"))
                                            : _createCommentVNode("v-if", true),
                                        _cache[59] || (_cache[59] = _createTextVNode()),
                                        (_ctx.isVisible('location'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_45, "Location"))
                                            : _createCommentVNode("v-if", true),
                                        _cache[60] || (_cache[60] = _createTextVNode()),
                                        (_ctx.isVisible('action'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_46, "Action"))
                                            : _createCommentVNode("v-if", true),
                                        _cache[61] || (_cache[61] = _createTextVNode()),
                                        (_ctx.isVisible('assigned'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_47, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'AssignedName', title: 'Assigned' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[62] || (_cache[62] = _createTextVNode()),
                                        (_ctx.isVisible('updated'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_48, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'WhenUpdated', title: 'Updated' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _cache[78] || (_cache[78] = _createTextVNode()),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            class: _normalizeClass(['pointer', 'alarm', { 'deleted': item.whenDeleted }, _ctx.getSeverityClass(item)]),
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, [
                                            _createElementVNode("td", {
                                                class: "text-center hidden-sm",
                                                onClick: _cache[14] || (_cache[14] = _withModifiers(() => { }, ["stop"]))
                                            }, [
                                                _createVNode(_component_b_button_group, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_dropdown, {
                                                            variant: "outline-secondary dots",
                                                            size: "sm",
                                                            onClick: ($event) => (_ctx.edit(item))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_dropdown_item, {
                                                                    onClick: ($event) => (_ctx.edit(item))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                                                            _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                            _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["onClick"]),
                                                                _cache[66] || (_cache[66] = _createTextVNode()),
                                                                _createVNode(_component_b_dropdown_divider),
                                                                _cache[67] || (_cache[67] = _createTextVNode()),
                                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                    onClick: ($event) => (_ctx.archive(item))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                                                            _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                            _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["onClick"]), [
                                                                    [_vShow, !item.whenDeleted]
                                                                ]),
                                                                _cache[68] || (_cache[68] = _createTextVNode()),
                                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                    onClick: ($event) => (_ctx.restore(item))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                                                            _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                            _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["onClick"]), [
                                                                    [_vShow, item.whenDeleted]
                                                                ])
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _cache[69] || (_cache[69] = _createTextVNode()),
                                            (_ctx.isVisible('issueId'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(item.issueNumber), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _cache[70] || (_cache[70] = _createTextVNode()),
                                            (_ctx.isVisible('created'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_51, _toDisplayString(_ctx.getFormattedDate(item.whenCreated)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _cache[71] || (_cache[71] = _createTextVNode()),
                                            (_ctx.isVisible('system'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_52, _toDisplayString(item.systemName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _cache[72] || (_cache[72] = _createTextVNode()),
                                            (_ctx.isVisible('description'))
                                                ? (_openBlock(), _createElementBlock("td", {
                                                    key: 3,
                                                    class: "large-text-ellipsis",
                                                    title: item.description
                                                }, _toDisplayString(item.description), 9 /* TEXT, PROPS */, _hoisted_53))
                                                : _createCommentVNode("v-if", true),
                                            _cache[73] || (_cache[73] = _createTextVNode()),
                                            (_ctx.isVisible('location'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(item.location), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _cache[74] || (_cache[74] = _createTextVNode()),
                                            (_ctx.isVisible('action'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(item.actionName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _cache[75] || (_cache[75] = _createTextVNode()),
                                            (_ctx.isVisible('assigned'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(item.assignedName || 'Unassigned'), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _cache[76] || (_cache[76] = _createTextVNode()),
                                            (_ctx.isVisible('updated'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(item.whenUpdated ? _ctx.getFormattedDate(item.whenUpdated) : ''), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ], 10 /* CLASS, PROPS */, _hoisted_49));
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                ]),
                                _cache[79] || (_cache[79] = _createTextVNode()),
                                _createElementVNode("tfoot", null, [
                                    (_ctx.noData)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [...(_cache[77] || (_cache[77] = [
                                                _createElementVNode("td", {
                                                    class: "text-center",
                                                    colspan: "8"
                                                }, [
                                                    _createElementVNode("h5", null, "There are no records matching your criteria.")
                                                ], -1 /* CACHED */)
                                            ]))]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.searchAttempted]
                    ])
                ])
            ])
        ])
    ]));
}
